import { BadgeCheck, Building2, ShieldCheck, Lock } from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, text: "RERA-registered projects only" },
  { icon: Building2, text: "NRI-friendly developers" },
  { icon: ShieldCheck, text: "No spam. No pressure." },
  { icon: Lock, text: "Your details stay private." },
];

export const TrustStrip = () => (
  <ul className="grid grid-cols-2 gap-x-4 gap-y-3 text-[13px] text-neutral-600" data-testid="trust-strip">
    {ITEMS.map(({ icon: Icon, text }) => (
      <li key={text} className="flex items-center gap-2">
        <Icon className="h-4 w-4 shrink-0 text-[#138808]" strokeWidth={1.8} />
        <span>{text}</span>
      </li>
    ))}
  </ul>
);
